// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */

import SVGComponent from "../../../SVGComponent";

/**
 * @param {Object} props
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {String} props.icon - Takes svg as an props
 * @param {String} props.title - title/tooltip of the button
 * @param {String} props.imgColor - Color for icon if needed (var Only)
 * @returns {JSX.Element}
 */
const CardActionableButton = ({
  handleFunction,
  isDisabled,
  icon,
  title,
  bgColor,
  imgColor,
}) => {
  return (
    <button
      title={title}
      type={"button"}
      onClick={(e) => {
        if (handleFunction) {
          e.stopPropagation();
          handleFunction(e);
        } else {
          return true;
        }
      }}
      style={{ backgroundColor: bgColor ? bgColor : "inherit" }}
      className={`flex z-z-index-base  relative justify-center  rounded-border-radius-md w-auto ${
        isDisabled
          ? "cursor-not-allowed opacity-light-opacity bg-primary-nav p-padding-xs"
          : !handleFunction
            ? " cursor-pointer"
            : bgColor
              ? "cursor-pointer global-hover-white p-padding-xs"
              : `cursor-pointer`
      }`}
    >
      <div className="flex flex-row items-center gap-gap-sm">
        <div className="h-icon-sm w-icon-sm flex-shrink-0">
          <SVGComponent
            url={icon}
            color={imgColor}
          />
        </div>
      </div>
    </button>
  );
};

export default CardActionableButton;
